import * as React from 'react';
import { pure } from 'recompose';

/* Style */
import './ButtonLink.scss';
/* Utils */

interface ButtonLinkProps {
  eventId: string;
  onClick: (input: string | Object) => void;
  htmlLabel: string;
  style: Object;
  title?: string;
  customer?: {};
}

class ButtonLink extends React.Component<ButtonLinkProps, {}> {
  getHTMLTitle = () => ({ __html: this.props.htmlLabel });

  handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    const { onClick, eventId, customer } = this.props;
    e.preventDefault();
    if (customer) onClick(customer);
    else onClick(eventId);
  };
  render() {
    const { style, title } = this.props;
    return (
      <button
        style={style}
        title={title}
        className="ButtonLink"
        onClick={this.handleClick}
        data-cypress="ButtonLink"
        dangerouslySetInnerHTML={this.getHTMLTitle()}
      />
    );
  }
}

export default pure(ButtonLink);
